import React, { useEffect } from 'react';
import { connect } from 'react-redux';


import TitleBar from '../../titleBar/titleBar';
import AgGridTable from '../../agGridComponent/agGridTable';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder'

import VendorActionButton from './vendorActionButton';

import { getVendor, updateVendor, deleteVendor } from '../../../redux/actions/vendorMasterActions';
import {HEADERS} from './vendorConstants'
import { FEATURES } from '../../../config/features';

function VendorTable(props) {

    const { getVendor, vendorData, vendorLoading, updateVendor, deleteVendor } = props;

    useEffect(() => {
        getVendor()
    }, [getVendor]);


    if (vendorLoading) {
        return (
            <React.Fragment>
                <TitleBar title="Partner" LinkName="" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { headerName: HEADERS.partner_name||'Partner Name', field: 'vendor', tooltipField: 'vendor', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.partner_code||'Partner Code', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'City', field: 'city', tooltipField: 'city', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.pincode||'Pincode', field: 'pincode', tooltipField: 'pincode', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Balance', field: 'balance', tooltipField: 'balance', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'GST #', field: 'gst', tooltipField: 'gst', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.pan_no||'PAN No.', field: 'pan', tooltipField: 'pan', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'State', field: 'state', tooltipField: 'state', enableRowGroup: true, enablePivot: true, filter: true },
            // { headerName: 'Credit Period', field: 'credit', tooltipField: 'credit', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.created_on||'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.created_by||'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.updated_on||'Modified On', field: 'updatedOn', tooltipField: 'updatedOn', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.updated_by||'Modified By', field: 'updatedBy', tooltipField: 'updatedBy', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.partner_type||'Vendor Type', field: 'vendorType', tooltipField: 'vendorType', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: HEADERS.action_buttons||'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" }
        ]

        let frameworkComponents = {
            actionRenderer: VendorActionButton,
        }

        let rowData = []

        vendorData && vendorData.length > 0 && vendorData.map((object, index) => {
            let temp = {}
            temp.vendor = object.transporterName
            temp.code = object.transporterCode
            temp.transporterMasterId = object.transporterMasterId
            temp.branch = ''
            temp.city = object.companyCity
            temp.pincode = object.companyPincode
            temp.balance = ''
            temp.gst = object.companyGst
            temp.pan = object.companyPan
            temp.state = ""
            temp.credit = ''
            temp.createdOn = object.createdOn
            temp.createdBy = object.createdBy
            temp.updatedOn = object.updatedOn
            temp.updatedBy = object.updatedBy
            temp.vendorType = object.vendorType
            temp.updateVendor = updateVendor
            temp.deleteVendor = deleteVendor

            rowData[index] = temp
        })


        return (
            <React.Fragment>
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    searchValue={props.searchValue}
                    link="/add-partner"
                    baseURL={props}
                    hiddenNewPopupBtn={true}
                    newPopup={props.newPopup}
                    hiddenImportPopupBtn={true}
                    extraComponents={frameworkComponents}
                    titleBarTitle="Partner"
                    handleSearch={props.handleSearch}
                    showImport={true}
                    fileName='transporterMaster'
                    path='transporterMaster'
                    disableFilter={true} 
                    master={true}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    }
}


const mapStatetoProps = (state) => ({
    vendorData: state.getVendorData.vendor.resultSet,
    vendorLoading: state.getVendorData.isLoading
})

export default connect(mapStatetoProps, { getVendor, updateVendor, deleteVendor })(VendorTable)